import { createContext, useContext } from 'react';
import { BdmBatchFile } from '../../../types/opm-pd-bdm-types';

type FormPolicy = BdmBatchFile['policies'][number] & {
  index: number;
  selectedOtherQualifiedAgent: {
    agentCode: string;
    fullname: string;
    label: string;
  } | null;
  displaySelectedAgent: string;
  displaySelectedAgentName: string;
  selectedOtherAgentReason: string;
  isDeleted: boolean;
};

export type BatchFilesSubmitPageContextType = {
  bdmBatchFile: BdmBatchFile | null;
  bdmBatchFileLoading: boolean;
  formFiles: any;
  formNote: string;
  formPolicies: FormPolicy[];
  isSubmitting: boolean;
  cancelBdmBatchFile: () => Promise<void>;
  submitBdmBatchFilePolicies: () => Promise<void>;
  setFormFiles: React.Dispatch<React.SetStateAction<any>>;
  setFormNote: React.Dispatch<React.SetStateAction<string>>;
  setPolicyFieldValue: (index: number, field: keyof FormPolicy, value: any) => void;
  addOtherQualifiedAgentToPolicy: (
    qualifiedAgents: { agentCode: string; fullname: string; label: string; policyNumbers: string[] }[],
  ) => void;
  removeFormPolicy: (index: number | number[]) => void;
};

export const BatchFilesSubmitPageContext = createContext<BatchFilesSubmitPageContextType>({
  bdmBatchFile: null,
  bdmBatchFileLoading: false,
  formFiles: null,
  formNote: '',
  formPolicies: [],
  isSubmitting: false,
  cancelBdmBatchFile: async () => {},
  submitBdmBatchFilePolicies: async () => {},
  setFormFiles: () => {},
  setFormNote: () => {},
  setPolicyFieldValue: () => {},
  addOtherQualifiedAgentToPolicy: () => {},
  removeFormPolicy: () => {},
});

export const useBatchFilesSubmitPageContext = (): BatchFilesSubmitPageContextType => {
  const context = useContext(BatchFilesSubmitPageContext);
  if (!context) {
    throw new Error('useBatchFilesSubmitPageContext must be used within a BatchFilesSubmitPageContext.Provider');
  }
  return context;
};
